<div class="dialog-container">
  <div class="dialog-header">
    <h2 mat-dialog-title>Neue Kategorie hinzufügen</h2>
    <button mat-icon-button (click)="onCancel()" class="close-button" matTooltip="Schließen">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-divider></mat-divider>

  <mat-dialog-content class="dialog-content">
    <p class="dialog-description">Geben Sie einen Namen für die neue Kategorie ein.</p>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Kategorie</mat-label>
      <input matInput [(ngModel)]="categoryName" placeholder="Kategoriename eingeben" autofocus>
      <mat-icon matSuffix>category</mat-icon>
      <mat-hint>Verwenden Sie einen beschreibenden Namen</mat-hint>
    </mat-form-field>
  </mat-dialog-content>

  <mat-divider></mat-divider>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()" class="cancel-button">
      <mat-icon>cancel</mat-icon> Abbrechen
    </button>
    <button mat-raised-button color="primary" (click)="onAdd()" [disabled]="!categoryName">
      <mat-icon>add</mat-icon> Hinzufügen
    </button>
  </mat-dialog-actions>
</div>
